export interface IWidgetInitializeOptions {
    currentUser: any;
    iid: string;
    did: string;
    root: HTMLElement;
    lang: any;
    params: any;
    rootUrl: any;
    page: any;
    widgetTopic: string;
    dashboards: Array<string>;
    container: any;
    popupTopic?: string;
}

export interface IWidget {
    initialize(options: IWidgetInitializeOptions): void | Promise<any>;
    destroy(): void;
}

export default class Widget {
    protected options: IWidgetInitializeOptions;       

    constructor() { }

    
    protected get container(): any {
        return this.options.container;
    }
    protected get currentUser(): any {
        return this.options.currentUser; 
    } 
    protected get currentLanguage(): any {
        return this.options.lang;
    }
    protected get definitionId(): string {
        return this.options.did;
    }
    protected get instanceId(): string {
        return this.options.iid;
    }    
    protected get parameters(): any {
        return this.options.params;
    }
    protected get mode(): 'Default' | 'Layout'  {
        return this.options.page.mode;
    }
    protected get inEditMode(): boolean {
        return this.mode === 'Layout';
    }
    protected set title(title: string) {
        this.setTitle(title);
    }
    protected get insidePopup(): boolean {
        if (this.options.popupTopic != null) {
            /* Widget itself is inside a popup (HTML control) */
            return true;
        } else {
            /* Check if widget is on a page that is inside a popup (iframe) */
            try {
                if (window != window.top) {
                    const $iframe = $(parent.document).find("iframe[name='" + window.name + "']");
                    const topic = $iframe.attr("topic");
                    if (topic != null && topic != '') {
                        return true;
                    }
                }
            } catch { }
        }

        /* Widget is not inside a popup */
        return false;
    }

    /**
     * DEPRECATED: use title property instead
     * @param title
     */
    protected setTitle(title: string) {
        this.container.setTitle(title);
    }
    
    



    public initialize(options: IWidgetInitializeOptions): void {
        this.options = options;
    }
    public destroy(): void {
    }
}
